var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-one-cont-h" },
    [
      _vm._l(_vm.item.ACTIONS, function (ACTION) {
        return _vm.item.ACTIONS
          ? _c("div", { staticClass: "actions" }, [
              ACTION.VALUE == "3547"
                ? _c("div", { staticClass: "item-promo-popular-peop" })
                : _vm._e(),
              _vm._v(" "),
              ACTION.VALUE == "3546"
                ? _c("div", { staticClass: "item-promo-akcii" })
                : _vm._e(),
              _vm._v(" "),
              ACTION.VALUE == "3545"
                ? _c("div", { staticClass: "item-promo-new" })
                : _vm._e(),
              _vm._v(" "),
              ACTION.VALUE == "3548"
                ? _c("div", { staticClass: "item-promo-xit" })
                : _vm._e(),
              _vm._v(" "),
              ACTION.VALUE == "3549"
                ? _c("div", { staticClass: "item-promo-rent-i" })
                : _vm._e(),
              _vm._v(" "),
              ACTION.VALUE == "6070"
                ? _c("div", { staticClass: "item-promo-del-i" })
                : _vm._e(),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c("div", { staticClass: "shop-one" }, [
        _c("div", { staticClass: "flex-cont" }, [
          _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
            _c("div", { staticClass: "shop-img" }, [
              _c("div", { staticClass: "gallery-one" }, [
                _c("img", {
                  attrs: {
                    src: _vm.item.GALLERY[0].src,
                    alt: _vm.item.NAME,
                    width: _vm.item.GALLERY[0].width,
                    height: _vm.item.GALLERY[0].height,
                    loading: "lazy",
                  },
                }),
              ]),
              _vm._v(" "),
              _vm.item.PRICE_OLD > 0
                ? _c(
                    "div",
                    { staticClass: "old-price-block-img old-price-block" },
                    [
                      _c("del", {
                        staticClass: "hide dis-pr-f",
                        domProps: {
                          innerHTML: _vm._s(_vm.item.FORMAT_PRICE_OLD),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dis-pr" }, [
                        _vm._v("-" + _vm._s(_vm.item.DISCOUNT_PR) + "%"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-list-card" }, [
          _c("div", { staticClass: "shop-name-container" }, [
            _c(
              "a",
              {
                staticClass: "shop-name",
                attrs: { href: _vm.item.DETAIL_PAGE_URL },
              },
              [
                _vm._v(
                  "\n                                " +
                    _vm._s(_vm.item.NAME) +
                    "\n                            "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pos-pr-rel" }, [
            _c("div", {
              staticClass: "price-list",
              domProps: { innerHTML: _vm._s(_vm.item.FORMAT_PRICE) },
            }),
            _vm._v(" "),
            _vm.item.PRICE_OLD > 0
              ? _c("div", { staticClass: "old-price-block" }, [
                  _c("del", {
                    staticClass: "dis-pr-f",
                    domProps: { innerHTML: _vm._s(_vm.item.FORMAT_PRICE_OLD) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dis-pr hide" }, [
                    _vm._v("-" + _vm._s(_vm.item.DISCOUNT_PR) + "%"),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "stars" },
            [
              _vm._l(5, function (star) {
                return _c("div", {
                  staticClass: "star",
                  class: { active: _vm.getRating(star, _vm.item) },
                })
              }),
              _vm._v(" "),
              _c("div", { staticClass: "count-feed" }, [
                _vm._v("(" + _vm._s(_vm.getCountFeed(_vm.item)) + ")"),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm.item.CUSTOM_OFFERS.length > 1
            ? _c("label", { staticClass: "label-variants" }, [
                _vm._v(
                  "Варианты исполнения (" +
                    _vm._s(_vm.item.CUSTOM_OFFERS.length) +
                    "):"
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.CUSTOM_OFFERS.length > 1
            ? _c("div", { staticClass: "block-variants" }, [
                _vm.item.CUSTOM_OFFERS
                  ? _c(
                      "div",
                      { staticClass: "link-variant" },
                      _vm._l(_vm.item.CUSTOM_OFFERS, function (offer, index) {
                        return _c(
                          "a",
                          {
                            class: { active: index == 0 },
                            attrs: { href: offer.DETAIL_PAGE_URL },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(
                                  offer.PROPS.OFFER_NAME
                                    ? offer.PROPS.OFFER_NAME[0].VALUE
                                    : offer.NAME
                                ) +
                                "\n                                    "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "eh-fast-order" }, [
            _c("div", { staticClass: "delivery-list" }, [
              _vm.item.PROPS.DELIVERY
                ? _c("b", [
                    _vm._v(_vm._s(_vm.item.PROPS.DELIVERY[0].VALUE_TEXT)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-ord-cart" }, [
              _c("div", [
                !_vm.item.BASKET
                  ? _c(
                      "a",
                      {
                        staticClass: "one-click-order feed-back-call-b",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.addToBasket(_vm.item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                                     Купить\n                                    "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.BASKET
                  ? _c(
                      "a",
                      {
                        staticClass: "one-click-order feed-back-call-b",
                        class: { active: _vm.item.BASKET },
                        attrs: { href: "/personal/cart/" },
                      },
                      [
                        _vm._v(
                          " \n                                        В корзину\n                                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eh-like-t" }, [
                !_vm.item.FAVORITE
                  ? _c("a", {
                      staticClass: "eh-like-e",
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.addToFavorite(_vm.item)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.FAVORITE
                  ? _c("a", {
                      staticClass: "eh-like-f",
                      class: { active: _vm.item.FAVORITE },
                      attrs: { href: "/favorite/" },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }